import { Select, ConfigProvider, InputNumber, DatePicker } from 'antd';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { Grid, Box, FormLabel, RadioGroup, FormControlLabel, Radio, Typography, Slider, Button } from '@mui/material';
import { USER_ROLE_FIELDS, MARKET_OPEN_TIME } from '../../../common/utility/constant';
// ============================================================
// NEW - Centralized Permission System
// See: src/common/hooks/usePermissions.js
// ============================================================
import usePermissions from '../../../common/hooks/usePermissions';
import FormControl from '@mui/material/FormControl';
import { Formik, Form, Field } from 'formik';
import { useAxiosWithAuth } from '../../../common/api/hooks/useAxiosWithAuth';
import { useState, useEffect } from 'react';
import { URL } from '../../../common/api/urls';
import { transformAndReverseMap } from '../../../common/utility/helperFunc';
import {GREEKS_TABLE_TARGET_TIME} from '../../../common/utility/table_constants';
import dayjs from 'dayjs';
import { formatDatesToISO } from '../../../common/utility/helperFunc';
import useAuth from '../../../common/hooks/useAuth.js';
import useSyncUidataNotifyFlags from '../../../common/hooks/useSyncUidataNotifyFlags';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(customParseFormat);
dayjs.extend(utc);
dayjs.extend(timezone);

let today = dayjs().tz("Asia/Kolkata");

function getSelectableTradeDates(tradeDates) {
  if (!Array.isArray(tradeDates)) return [];
  
  const sorted = [...tradeDates].sort();
    const lastTwo = sorted.slice(-3);

  console.log("today", today);
  
  const upcomingFour = [];
  upcomingFour.push(today.format('YYYY-MM-DD'));
  let currentDate = today.add(1, 'day'); 
  
  while (upcomingFour.length < 50) {
    const dayOfWeek = currentDate.day();
    
    if (dayOfWeek !== 0 && dayOfWeek !== 6) {
      upcomingFour.push(currentDate.format('YYYY-MM-DD'));
    }
    
    currentDate = currentDate.add(1, 'day');
  }
  
  return [...new Set([...lastTwo, ...upcomingFour])];
}


export const PayoffHeader = ({ 
  onInstrumentSelect,
  plotInstrumentList,
  currentDateTime,
  posDelta
}) => {
  const { auth, setAuth } = useAuth();
  const syncUidataNotifyFlags = useSyncUidataNotifyFlags();
  const { Option } = Select;
  const [cancelUI, responseDataUI, errorUI, loadedUI, resetUI, executeAPIUI] = useAxiosWithAuth();
  const [cancelGetActivePos, responseGetActivePos, errorGetActivePos, loadedGetActivePos, resetGetActivePos, executGetActivePos] = useAxiosWithAuth();
  const [options, setOptions] = useState([]);
  const [instrumentList, setInstrumentList] = useState([]);
  const [instrList, setInstrList] = useState([]);
  const [dateList, setDateList] = useState([]);
  const [getActiveBrokerPos, setGetActiveBrokerPos] = useState(false);
  const [brokerMdata, setBrokerMdata] = useState({});
  const [availableDates, setAvailableDates] = useState([]);
  // ============================================================
  // NEW - Centralized Permission System
  // See: src/common/utility/permissionService.js
  // ============================================================
  const permissions = usePermissions();
  
  // ============================================================
  // OLD - Hardcoded Admin check (DEPRECATED)
  // Replaced by: permissions.isAdmin()
  // See: src/common/utility/permissionService.js
  // ============================================================
  // const isAdmin = (auth.role.find(el => el == USER_ROLE_FIELDS.ADMIN)) ? true : false;
  
  // NEW - Use centralized permission service
  const isAdmin = permissions.isAdmin();
  
  console.log("currentDateTime", currentDateTime)
  if(currentDateTime != "undefined undefined")
    today = dayjs.tz(currentDateTime, "DD-MM-YYYY HH:mm", "Asia/Kolkata");
  console.log("today", today);

  useEffect(() => {
    let data = {
      "symbol": "NIFTY",
      "watchlist_instruments": 1,
      "optchain_tdates": 1,
      // "dateList": 1
    };
    executeAPIUI(URL.MPCHART_UIDATA, "POST", data);
  }, []);

  useEffect(() => {
    if (loadedUI) {
      if (responseDataUI != null) {
        responseDataUI.wl_instruments = responseDataUI.wl_instruments.map((item) =>
          transformAndReverseMap(item)
        );
        // console.log("this", responseDataUI.optchain_tdates)
        if (responseDataUI.optchain_tdates)
          responseDataUI.optchain_tdates = formatDatesToISO(responseDataUI.optchain_tdates);
        console.log("responseDataUI tdates=", responseDataUI.optchain_tdates);
        
        if (responseDataUI.optchain_tdates.length > 0) {
          const dates = getSelectableTradeDates(responseDataUI.optchain_tdates);
          console.log("Selectable Trade Dates:", dates);
          setAvailableDates(dates);
          console.log("Available Dates:", availableDates);
        }
        console.log("responseDataUI=", responseDataUI.wl_instruments);
        setOptions(responseDataUI.wl_instruments);
        syncUidataNotifyFlags(responseDataUI);
      }
    }
  }, [loadedUI]);

  useEffect(() => {
    if (loadedGetActivePos) {
      setGetActiveBrokerPos(true);
      console.log("getting active pos")
      if (responseGetActivePos != null) {
        console.log("activepos", responseGetActivePos);
        setInstrumentList(responseGetActivePos.ui_instruments_data);
        setBrokerMdata(responseGetActivePos.broker_mdata);
      }
    }
  }, [loadedGetActivePos, responseGetActivePos]);

  const isDateAvailable = (current) => {
    return availableDates.some(date => current.isSame(date, 'day'));
  };

  //Clear all selected instruments and dates
  const resetPayoff = () => {
    setInstrumentList([]);
    setInstrList([]);
    setDateList([]);

    onInstrumentSelect({
      instrumentData: [],
      dateData: [],
    });

  };

  // Add the removeInstrument function
  const removeInstrument = (indexToRemove) => {
    const updatedList = instrumentList.filter((_, index) => index !== indexToRemove);
    const updatedInstrList = instrList.filter((_, index) => index !== indexToRemove);
    
    setInstrumentList(updatedList);
    setInstrList(updatedInstrList);
    
    // Call onInstrumentSelect to update the parent component
    const data = updatedList.map(item => ({
      "instrument": item.instrument,
      "size": item.size,
    }));
    
    if (dateList.length > 0) {
      const dateData = dateList.map(item => ({
        "targetDate": item.targetDate,
        "targetTime": item.targetTime,
      }));
      onInstrumentSelect({
        instrumentData: data,
        dateData: dateData,
      });
    } else {
      onInstrumentSelect({
        instrumentData: data,
      });
    }
  };
  
  const updateInstrument = (index, field, value) => {
    const updatedList = [...instrumentList];
    
    if (field === 'quantity') {
      // Update size based on current direction (positive for LONG, negative for SHORT)
      const isLong = updatedList[index].size > 0;
      updatedList[index].size = isLong ? value : -value;
    } else if (field === 'direction') {
      // Update direction (LONG/SHORT) while preserving quantity
      const currentQuantity = Math.abs(updatedList[index].size);
      updatedList[index].size = value === 'LONG' ? currentQuantity : -currentQuantity;
    }
    setInstrumentList(updatedList);
    
    // Call onInstrumentSelect to update the parent component
    const data = updatedList.map(item => ({
      "instrument": item.instrument,
      "size": item.size,
    }));
    
    if (dateList.length > 0) {
      const dateData = dateList.map(item => ({
        "targetDate": item.targetDate,
        "targetTime": item.targetTime,
      }));
      onInstrumentSelect({
        instrumentData: data,
        dateData: dateData,
      });
    } else {
      onInstrumentSelect({
        instrumentData: data,
      });
    }
  };

  const removeDate = (indexToRemove) => {
    const updatedList = dateList.filter((_, index) => index !== indexToRemove);
    setDateList(updatedList);
    console.log("Date removed, updated dateList:", updatedList);
    
    // update the parent component
    const data = instrumentList.map(item => ({
      "instrument": item.instrument,
      "size": item.size,
    }));
    
    if (updatedList.length > 0) {
      const dateData = updatedList.map(item => ({
        "targetDate": item.targetDate,
        "targetTime": item.targetTime,
      }));
      onInstrumentSelect({
        instrumentData: data,
        dateData: dateData,
      });
    } else {
      onInstrumentSelect({
        instrumentData: data,
      });
    }
  };
  
  // Function to update date or time
  const updateDate = (index, field, value) => {
    const updatedList = [...dateList];
    const currentItem = {...updatedList[index]};
    
    // Check if we're updating date or time
    if (field === 'targetDate') {
      currentItem.targetDate = dayjs(value).format('DD-MM-YYYY');
      
      // Recalculate type based on the new date and existing time
      const dateTimeString = `${value}T${currentItem.targetTime}`;
      const selectedDateTime = dayjs(dateTimeString);
      currentItem.type = selectedDateTime.isBefore(today) ? 'past' : 'future';
    } else if (field === 'targetTime') {
      currentItem.targetTime = value;
      
      const dateParts = currentItem.targetDate.split('-');
      const isoDate = `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`;
      
      const dateTimeString = `${isoDate}T${value}`;
      const selectedDateTime = dayjs(dateTimeString);
      currentItem.type = selectedDateTime.isBefore(today) ? 'past' : 'future';
    }
    
    // Check for type conflicts
    const otherDates = dateList.filter((_, i) => i !== index);
    const hasConflict = otherDates.some(item => item.type === currentItem.type);
    
    if (hasConflict) {
      console.log(`Cannot update: would create two ${currentItem.type} dates`);
      return false;
    }
    
    // Update the date 
    updatedList[index] = currentItem;
    setDateList(updatedList);
    
    // update the parent component
    const data = instrumentList.map(item => ({
      "instrument": item.instrument,
      "size": item.size,
    }));
    
    const dateData = updatedList.map(item => ({
      "targetDate": item.targetDate,
      "targetTime": item.targetTime,
    }));
    
    onInstrumentSelect({
      instrumentData: data,
      dateData: dateData,
    });
    
    return true;
  };
  
  console.log("Trade Dates:", availableDates);

  const FormikSelect = ({ field, form, ...props }) => {
    const { name, value } = field;
    const { setFieldValue } = form;

    return (
      <Select
        {...props}
        value={value || undefined}
        onChange={(selectedValue) => {
          console.log('Dropdown selection changed:', selectedValue);
          setFieldValue(name, selectedValue);
        }}
        onBlur={() => form.setFieldTouched(name, true)}
      >
        {options.map((item) => (
          <Option key={item.instr} value={item.instr} style={{fontSize:"12px"}}>
            {item.name}
          </Option>
        ))}
      </Select>
    );
  };

  const FormikInputNumber = ({ field, form, ...props }) => {
    const { name, value } = field;
    const { setFieldValue } = form;

    return (
      <InputNumber
        {...props}
        value={value}
        onChange={(newValue) => {
          setFieldValue(name, newValue || 1);
        }}
        onBlur={() => form.setFieldTouched(name, true)}
      />
    );
  };

  const initialValues = {
    instrument: 'NIFTY',
    option: 'LONG',
    quantity: 1,
  };

  const dateInitialValues = {
    targetDate: today.format('YYYY-MM-DD'),
    targetTime: {
      value: 0,
      time: MARKET_OPEN_TIME
    }
  };

const handleSubmit = (values, { setSubmitting, resetForm }) => {
  console.log("Form submitted with values:", values);
  const selectedOption = options.find(option => option.instr === values.instrument);

  const size = values.option === "LONG"
    ? values.quantity
    : -values.quantity;

  console.log("debug", values.instrument, instrList, instrList.includes(values.instrument))
  const newInstrument = {
    instrument: values.instrument,
    name: selectedOption.name,
    size: size
  };
  if(!instrList.includes(values.instrument)){
    const updatedInstrList = [...instrList, values.instrument];
    const updatedInstrumentList = [...instrumentList, newInstrument];
    
    setInstrList(updatedInstrList);
    setInstrumentList(updatedInstrumentList);
    
    // Call onInstrumentSelect immediately to update the parent component
    const data = updatedInstrumentList.map(item => ({
      "instrument": item.instrument,
      "size": item.size,
    }));
    
    if (dateList.length > 0) {
      const dateData = dateList.map(item => ({
        "targetDate": item.targetDate,
        "targetTime": item.targetTime,
      }));
      onInstrumentSelect({
        instrumentData: data,
        dateData: dateData
      });
    } else {
      onInstrumentSelect({
        instrumentData: data,
      });
    }
  }

  setSubmitting(false);
  resetForm();
};

const handleDateSubmit = (values, { setSubmitting, resetForm }) => {
    console.log("Date form submitted with values:", values);

    if (!values.targetDate || !values.targetTime.time) {
      alert("Please select both date and time");
      setSubmitting(false);
      return;
    }

    const selectedDateTime = dayjs(`${values.targetDate}T${values.targetTime.time}`);

    const type = selectedDateTime.isBefore(today) ? 'past' : 'future';
    const formattedDate = dayjs(values.targetDate).format('DD-MM-YYYY');

    const newTargetDate = {
      targetDate: formattedDate,
      targetTime: values.targetTime.time,
      type: type
    };
    console.log("New Target Date:", newTargetDate);

    const updatedList = [
      ...dateList.filter(item => item.type !== type),
      newTargetDate
    ];
    setDateList(updatedList);

    setSubmitting(false);
    resetForm();
    const data = instrumentList.map(item => ({
      "instrument": item.instrument,
      "size": item.size,
    }));
    
    const dateData = updatedList.map(item => ({
      "targetDate": item.targetDate,
      "targetTime": item.targetTime,
    }));
    
    onInstrumentSelect({
      instrumentData: data,
      dateData: dateData,
    });
  };

  const plotChart = () => {
    // if (instrumentList.length === 0) {
    //   alert("Please select at least one instrument to plot the chart.");
    //   return;
    // }
    if (instrumentList.length !== 0 || dateList.length !== 0) {
      const data = instrumentList.map(item => ({
        "instrument": item.instrument,
        "size": item.size,
      }));
      const dateData = dateList.map(item => ({
        "targetDate": item.targetDate,
        "targetTime": item.targetTime,
      }));
      onInstrumentSelect({
        instrumentData: data,
        dateData: dateData,
      });
    }
    else {
      const data =instrumentList.map(item => ({
          "instrument": item.instrument,
          "size": item.size,
        }))
          onInstrumentSelect({
            instrumentData: data,
        });
      }
  };

  const getBrokerPos = () => {
    let data = {
      instruments: [],
      payoff_per_option: false,
      get_active_broker_positions: true
    };
    console.log('Executing get broker pos API with data:', data);
    executGetActivePos(URL.PAYOFFCHART, "POST", data);
  };

  return (
    <ConfigProvider
      theme={{
        components: {
          Select: {
            colorPrimary: '#2f5cdb',
            colorBgContainer: "#1a2332",
            optionActiveBg: "#22314E",
            colorText: "#FFFFFF",
            optionSelectedBg: "#35445E",
            selectorBg: "#1a2332",
            colorIcon: "#FFFFFF",
            colorTextDisabled: "#899499",
            colorBorder: "#35445E",
            colorBgElevated: "#1a2332",
            colorTextPlaceholder: "#FFFFFF",
          },
          InputNumber: {
            colorPrimary: '#2f5cdb',
            colorBgContainer: "#1a2332",
            colorText: "#FFFFFF",
            colorBorder: "#35445E",
            colorIcon: "#FFFFFF"
          },
        },
      }}
    >
      <div style={{ 
        backgroundColor: '#0d203f', 
        padding: '20px', 
        borderRadius: '8px',
        minHeight: '200px',
        width: '100%',
      }}>
        <Typography 
          variant="h6" 
          sx={{ 
            color: '#FFFFFF', 
            marginBottom: '20px',
            textAlign: 'left',
            fontWeight: 600
          }}
        >
          Instrument Selection
        </Typography>
        
        {options.length > 0 ? (
          <><Formik
            initialValues={initialValues}
            onSubmit={handleSubmit}
            enableReinitialize={true}
          >
            {({ values, errors, touched, isSubmitting }) => (
              <Form>
                <Grid container spacing={3}>
                  {/* Instrument Selection */}
                  <Grid item xs={12} md={6}>
                    <Box sx={{ marginBottom: '16px' }}>
                      <FormLabel
                        sx={{
                          color: '#FFFFFF',
                          display: 'block',
                          marginBottom: '8px',
                          fontSize: '14px',
                          fontWeight: 500
                        }}
                      >
                        Select Instrument
                      </FormLabel>
                      <Field name="instrument">
                        {(fieldProps) => (
                          <FormikSelect
                            {...fieldProps}
                            variant="borderless"
                            suffixIcon={<ArrowDropDownIcon sx={{ color: '#FFFFFF' }} />}
                            showSearch
                            style={{
                              width: 250,
                              height: 40,
                            }}
                            placeholder="Search Instrument"
                            optionFilterProp="children"
                            filterOption={(input, option) => {
                              const words = input.trim().toLowerCase().split(' ');
                              return words.every(word => option.props.children.toLowerCase().includes(word)
                              );
                            } } />
                        )}
                      </Field>
                      {errors.instrument && touched.instrument && (
                        <div style={{ color: '#ff4d4f', fontSize: '12px', marginTop: '4px' }}>
                          {errors.instrument}
                        </div>
                      )}
                    </Box>
                  </Grid>

                  {/* Quantity Selection */}
                  <Grid item xs={12} md={6}>
                    <Box sx={{ marginBottom: '16px' }}>
                      <FormLabel
                        sx={{
                          color: '#FFFFFF',
                          display: 'block',
                          marginBottom: '8px',
                          fontSize: '14px',
                          fontWeight: 500
                        }}
                      >
                        Quantity
                      </FormLabel>
                      <Field name="quantity">
                        {(fieldProps) => (
                          <FormikInputNumber
                            {...fieldProps}
                            min={1}
                            max={1000}
                            style={{
                              width: '80px',
                              height: '32px',
                            }}
                            placeholder="Enter quantity" />
                        )}
                      </Field>
                    </Box>
                  </Grid>

                  {/* Buy/Sell Options */}
                  <Grid item xs={12}>
                    <Box sx={{ marginBottom: '20px' }}>
                      <Field name="option">
                        {({ field }) => (
                          <FormControl component="fieldset">
                            <FormLabel
                              sx={{
                                color: '#FFFFFF',
                                marginBottom: '8px',
                                fontSize: '14px',
                                fontWeight: 500,
                                '&.Mui-focused': {
                                  color: '#FFFFFF'
                                }
                              }}
                            >
                              Transaction Type
                            </FormLabel>
                            <Box
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                background: '#22314a',
                                borderRadius: '22px',
                                width: '140px',
                                height: '36px',
                                p: '2px',
                                boxShadow: '0 1px 4px 0 rgba(0,0,0,0.10)'
                              }}
                            >
                              <div
                                onClick={() => field.onChange({ target: { name: field.name, value: 'LONG' } })}
                                style={{
                                  flex: 1,
                                  textAlign: 'center',
                                  cursor: 'pointer',
                                  padding: '5px 0',
                                  borderRadius: '20px',
                                  background: field.value === 'LONG' ? '#32c19bff' : 'transparent',
                                  color: field.value === 'LONG' ? '#fff' : '#b0b8c1',
                                  fontWeight: 500,
                                  fontSize: '15px',
                                  transition: 'background 0.2s, color 0.2s'
                                }}
                              >
                                LONG
                              </div>
                              <div
                                onClick={() => field.onChange({ target: { name: field.name, value: 'SHORT' } })}
                                style={{
                                  flex: 1,
                                  textAlign: 'center',
                                  cursor: 'pointer',
                                  padding: '5px 0',
                                  borderRadius: '20px',
                                  background: field.value === 'SHORT' ? '#cc9b29ff' : 'transparent',
                                  color: field.value === 'SHORT' ? '#fff' : '#b0b8c1',
                                  fontWeight: 500,
                                  fontSize: '15px',
                                  transition: 'background 0.2s, color 0.2s'
                                }}
                              >
                                SHORT
                              </div>
                            </Box>
                          </FormControl>
                        )}
                      </Field>
                    </Box>
                  </Grid>

                  {/* Submit Button */}
                  <Grid item xs={12}>
                    <Box display="flex" justifyContent="center" gap={2}>
                      <button
                        type="submit"
                        disabled={isSubmitting}
                        style={{
                          // padding: '12px 32px',
                          marginTop: '22px',
                          marginLeft: '20px',
                          backgroundColor: isSubmitting ? '#4a4a4a' : '#2f5cdb',
                          color: 'white',
                          border: 'none',
                          borderRadius: '6px',
                          cursor: isSubmitting ? 'not-allowed' : 'pointer',
                          fontSize: '14px',
                          fontWeight: 500,
                          minWidth: '150px',
                          height: '40px',
                          transition: 'background-color 0.3s ease',
                          boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                        }}
                        onMouseOver={(e) => {
                          if (!isSubmitting) {
                            e.target.style.backgroundColor = '#1e4cb3';
                          }
                        }}
                        onMouseOut={(e) => {
                          if (!isSubmitting) {
                            e.target.style.backgroundColor = '#2f5cdb';
                          }
                        }}
                      >
                        {isSubmitting ? 'Processing...' : 'Add Instrument'}
                      </button>
                    </Box>
                    </Grid>
                </Grid>
              </Form>
            )}
          </Formik>
            <hr/>
        <Typography 
          variant="h6" 
          sx={{ 
            color: '#FFFFFF', 
            marginTop: '20px',
            marginBottom: '20px',
            textAlign: 'left',
            fontWeight: 600
          }}
        >
          Time and Date Selection
        </Typography>
          
          <Formik
            initialValues={dateInitialValues}
            onSubmit={handleDateSubmit}
            enableReinitialize={true}
          >
            {({ values, errors, touched, isSubmitting, setFieldValue }) => (
              <Form>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={3}>
                    <FormLabel
                      sx={{
                        color: '#FFFFFF',
                        display: 'block',
                        // marginTop: '20px',
                        marginBottom: '8px',
                        marginLeft: '0px',
                        fontSize: '14px',
                        fontWeight: 500
                      }}
                    >
                      Target Date
                    </FormLabel>
                    <Field name="targetDate">
                      {({ field, form }) => (
                        <DatePicker
                          // selected={form.values.targetDate || undefined}
                          value={dayjs(form.values.targetDate, 'YYYY-MM-DD')}
                          onChange={(selectedValue) => {
                            const formatted = selectedValue.format('YYYY-MM-DD');
                            form.setFieldValue('targetDate', formatted);
                          }}                          
                          // onBlur={() => form.setFieldTouched('targetDate', true)}
                          disabledDate={(current) => {
                            return !isDateAvailable(current);
                          }}
                          allowClear={false}
                          placeholderText="Select Date"
                          style={{
                            border: "1px solid #415e81",
                            background: "#1a2332",
                            borderRadius: "4px",
                          }}
                        />
                      )}
                    </Field>
                    {touched.targetDate && errors.targetDate && (
                      <div style={{ color: '#ff4d4f', fontSize: '12px', marginTop: '4px' }}>
                        {errors.targetDate}
                      </div>
                    )}
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <FormLabel
                      sx={{
                        color: '#FFFFFF',
                        display: 'flex',
                        marginBottom: '8px',
                        fontSize: '14px',
                        fontWeight: 500
                      }}
                    >
                      Select Time
                    </FormLabel>
                    <Field name="targetTime">
                      {({ field, form }) => (
                        <Box >
                          <Slider
                            value={form.values.targetTime?.value ?? 0}
                            onChange={(event, newValue) => {
                              console.log('Slider changed:', newValue);
                              const selectedMark = GREEKS_TABLE_TARGET_TIME.find(mark => mark.value === newValue);
                              form.setFieldValue('targetTime', {
                                value: newValue,
                                time: selectedMark?.time || ''
                              });
                            }}
                            step={5}
                            marks={GREEKS_TABLE_TARGET_TIME}
                            min={0}
                            max={125}
                            style={{
                              width: 300,
                            }}
                          />
                        </Box>
                      )}
                    </Field>
                    {touched.targetTime && errors.targetTime && (
                      <div style={{ color: '#ff4d4f', fontSize: '14px', marginTop: '4px' }}>
                        {errors.targetTime}
                      </div>
                    )}
                  </Grid>

                  <Grid item xs={12} md={2}>
                    <Box>
                      <Typography sx={{ color: '#FFFFFF', fontSize: '16px', marginBottom: '4px' }}>
                        Time:
                      </Typography>
                      <Typography sx={{ color: '#FFFFFF', fontSize: '16px', fontWeight: 500 }}>
                        {values.targetTime?.time || 'None'}
                      </Typography>
                    </Box>
                  </Grid>

                  <Grid item xs={12} md={2}>
                    <Button
                      type="submit"
                      disabled={isSubmitting}
                      variant="contained"
                      sx={{
                        backgroundColor: isSubmitting ? '#4a4a4a' : '#2f5cdb',
                        color: 'white',
                        borderRadius: '6px',
                        fontSize: '14px',
                        fontWeight: 500,
                        height: '40px',
                        minWidth: '150px',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                        '&:hover': {
                          backgroundColor: '#1e4cb3'
                        },
                        '&:disabled': {
                          backgroundColor: '#2f5cdb'
                        }
                      }}
                    >
                      {isSubmitting ? 'Adding...' : ' Add / Update '}
                    </Button>
                  </Grid>
                </Grid>
              </Form>
            )}
          </Formik>
          <hr/>
          <Box
            display="flex"
            justifyContent="left"
            alignItems="flex-start" 
            sx={{
              minHeight: '100px',
              color: '#FFFFFF',
              fontSize: '16px',
              marginTop: '20px',
              marginBottom: '10px',
            }}
          >
              {instrumentList?.length > 0 || dateList?.length > 0 ? (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '24px', width: '100%' }}>
                  
                  {/* Dates Section */}
                  <div>
                    <Typography variant="subtitle1" sx={{ color: '#FFFFFF', marginBottom: '2px', fontWeight: 600 }}>
                      Selected Dates:
                    </Typography><em>Only 1 Past date/time and 1 Future date/time can be selected at a time.<br/>A newer selection overwrites the earlier value</em>
                    <div style={{ display: 'grid', gap: '8px', marginTop:'16px', width: '100%' }}>
                      {dateList.length > 0 ? (
                        dateList.map((item, index) => (
                          <div 
                            key={index} 
                            style={{ 
                              display: 'grid',
                              gridTemplateColumns: '1fr 1fr auto',
                              alignItems: 'center',
                              backgroundColor: 'rgba(255, 255, 255, 0.1)',
                              padding: '12px 16px',
                              borderRadius: '8px',
                              border: '1px solid rgba(255, 255, 255, 0.2)'
                            }}
                          >
                            {/* Date Selector */}
                            <div style={{ 
                              display: 'flex', 
                              flexDirection: 'column',
                              marginRight: '10px'
                            }}>
                              <div style={{ 
                                color: item.type === 'past' ? '#ff8000' : '#0099ff', 
                                fontSize: '14px',
                                fontWeight: 'bold',
                                marginBottom: '6px'
                              }}>
                                {item.type === 'past' ? 'Older date:' : 'Future date:'}
                              </div>
                              <DatePicker
                                value={dayjs(item.targetDate, 'DD-MM-YYYY')}
                                allowClear={false}
                                onChange={(selectedValue) => {
                                // Try to update, if it returns false (conflict), show error
                                  const formatted = selectedValue.format('YYYY-MM-DD');
                                  const success = updateDate(index, 'targetDate', formatted);
                                  if (!success) {
                                    alert(`Cannot change to ${formatted}. This would create a conflict with another date of the same type.`);
                                    return;
                                  }
                                }}                     
                              disabledDate={(current) => {
                                const formatted = current.format('YYYY-MM-DD');
                                const dateTimeString = `${formatted}T${item.targetTime}`;
                                const selectedDateTime = dayjs(dateTimeString);

                                const wouldBePast = selectedDateTime.isBefore(today);
                                const wouldBeFuture = !wouldBePast;

                                const isAllowedDate = availableDates.includes(formatted);
                                const otherDates = dateList.filter((_, i) => i !== index);

                                const hasConflict = otherDates.some(otherItem =>
                                  (wouldBePast && otherItem.type === 'past') ||
                                  (wouldBeFuture && otherItem.type === 'future')
                                );

                                return !isAllowedDate || hasConflict;
                              }}
                              placeholderText="Select Date"
                              style={{
                                border: "1px solid #415e81",
                                background: "#1a2332",
                                borderRadius: "4px",
                              }}
                            />
                            </div>
                            
                            {/* Time Selector */}
                            <div style={{ 
                              display: 'flex', 
                              flexDirection: 'column',
                              marginRight: '10px'
                            }}>
                              <div style={{ 
                                color: item.type === 'past' ? '#ff8000' : '#0099ff', 
                                fontSize: '14px',
                                fontWeight: 'bold',
                                marginBottom: '6px'
                              }}>
                                Time:
                              </div>
                              <Select
                                value={item.targetTime}
                                onChange={(selectedValue) => {
                                  // Try to update, if it returns false (conflict), show error
                                  const success = updateDate(index, 'targetTime', selectedValue);
                                  if (!success) {
                                    alert(`Cannot change to ${selectedValue}. This would create a conflict with another date of the same type.`);
                                  }
                                }}
                                style={{
                                  width: '100%',
                                  backgroundColor: 'rgba(255, 255, 255, 0.05)',
                                }}
                                popupStyle={{
                                  backgroundColor: '#2a2a2a',
                                }}
                                suffixIcon={<ArrowDropDownIcon sx={{ color: '#FFFFFF' }} />}
                              >
                                {GREEKS_TABLE_TARGET_TIME.map((timeOption) => {
                                  // Extract date from formatted date (DD-MM-YYYY to YYYY-MM-DD)
                                  const dateParts = item.targetDate.split('-');
                                  const isoDate = `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`;
                                  
                                  // Check if selecting this time would cause a type conflict
                                  const dateTimeString = `${isoDate}T${timeOption.time}`;
                                  const selectedDateTime = dayjs(dateTimeString);
                                  const wouldBePast = selectedDateTime.isBefore(today);
                                  const wouldBeFuture = !wouldBePast;
                                  
                                  // Check if this would conflict with other dates
                                  const otherDates = dateList.filter((_, i) => i !== index);
                                  const hasConflict = otherDates.some(otherItem => 
                                    (wouldBePast && otherItem.type === 'past') || 
                                    (wouldBeFuture && otherItem.type === 'future')
                                  );
                                  
                                  return (
                                    <Option 
                                      key={timeOption.value} 
                                      value={timeOption.time}
                                      disabled={hasConflict}
                                      style={{
                                        fontSize: '12px',
                                        color: wouldBePast ? '#ff8000' : '#0099ff',
                                        backgroundColor: hasConflict ? 'rgba(255, 0, 0, 0.1)' : 'transparent'
                                      }}
                                    >
                                      {timeOption.time}
                                      {hasConflict}
                                    </Option>
                                  );
                                })}
                              </Select>
                            </div>
                            
                            {/* Remove Button */}
                            <div
                              onClick={() => removeDate(index)}
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: '32px',
                                height: '32px',
                                borderRadius: '50%',
                                backgroundColor: 'rgba(255, 68, 68, 0.7)',
                                color: '#ffffff',
                                fontSize: '20px',
                                fontWeight: 'bold',
                                cursor: 'pointer',
                                transition: 'all 0.2s',
                                border: '1px solid #ff4444',
                                boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
                                alignSelf: 'center',
                                marginTop: '20px'
                              }}
                              onMouseOver={(e) => {
                                e.target.style.backgroundColor = '#ff4444';
                                e.target.style.transform = 'scale(1.1)';
                              }}
                              onMouseOut={(e) => {
                                e.target.style.backgroundColor = 'rgba(255, 68, 68, 0.7)';
                                e.target.style.transform = 'scale(1)';
                              }}
                            >
                              ×
                            </div>
                          </div>
                        ))
                      ) : (
                        <Typography variant="body2" sx={{ color: '#FFFFFF', opacity: 0.7 }}>
                          No dates selected yet.
                        </Typography>
                      )}
                    </div>
                  </div>
                  
                  {/* Instruments Grid */}
                  <div>
                    <Typography variant="subtitle1" sx={{ color: '#FFFFFF', marginBottom: '16px', fontWeight: 600 }}>
                      Selected Instruments:
                    </Typography>
                    <div style={{ display: 'grid', gap: '8px', width: '100%' }}>
                      {instrumentList.length > 0 ? (
                        instrumentList.map((item, index) => (
                          <div 
                            key={index} 
                            style={{ 
                              display: 'flex',
                              alignItems: 'center',
                              backgroundColor: 'rgba(255, 255, 255, 0.1)',
                              padding: '8px 12px',
                              borderRadius: '8px',
                              border: '1px solid rgba(255, 255, 255, 0.2)',
                              gap: '10px'
                            }}
                          >
                            {/* Instrument Name (non-editable) */}
                            <div style={{ 
                              color: '#FFFFFF', 
                              fontSize: '14px',
                              fontWeight: 500,
                              flex: '1',
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis'
                            }}>
                              {item.name}
                            </div>
                            
                            {/* Quantity Input */}
                            <InputNumber
                              min={1}
                              max={1000}
                              value={Math.abs(item.size)}
                              onChange={(value) => updateInstrument(index, 'quantity', value)}
                              style={{
                                width: '80px',
                                height: '32px',
                                margin: '0 4px'
                              }}
                            />
                            
                            {/* LONG/SHORT Toggle */}
                            <Box sx={{ 
                              display: 'flex', 
                              alignItems: 'center', 
                              background: '#22314a', 
                              borderRadius: '22px', 
                              width: '140px', 
                              height: '36px', 
                              p: '2px', 
                              boxShadow: '0 1px 4px 0 rgba(0,0,0,0.10)' 
                            }}>
                              <div 
                                onClick={() => updateInstrument(index, 'direction', 'LONG')} 
                                style={{ 
                                  flex: 1, 
                                  textAlign: 'center', 
                                  cursor: 'pointer', 
                                  padding: '5px 0', 
                                  borderRadius: '20px', 
                                  background: item.size > 0 ? '#32c19bff' : 'transparent', 
                                  color: item.size > 0 ? '#fff' : '#b0b8c1', 
                                  fontWeight: 500, 
                                  fontSize: '15px', 
                                  transition: 'background 0.2s, color 0.2s' 
                                }}
                              >
                                LONG
                              </div>
                              <div 
                                onClick={() => updateInstrument(index, 'direction', 'SHORT')} 
                                style={{ 
                                  flex: 1, 
                                  textAlign: 'center', 
                                  cursor: 'pointer', 
                                  padding: '5px 0', 
                                  borderRadius: '20px', 
                                  background: item.size < 0 ? '#cc9b29ff' : 'transparent', 
                                  color: item.size < 0 ? '#fff' : '#b0b8c1', 
                                  fontWeight: 500, 
                                  fontSize: '15px', 
                                  transition: 'background 0.2s, color 0.2s' 
                                }}
                              >
                                SHORT
                              </div>
                            </Box>
                            
                            {/* Delete (X) Button */}
                            <div 
                              onClick={() => removeInstrument(index)}
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: '32px',
                                height: '32px',
                                borderRadius: '50%',
                                backgroundColor: 'rgba(255, 68, 68, 0.7)',
                                color: '#ffffff',
                                fontSize: '20px',
                                fontWeight: 'bold',
                                cursor: 'pointer',
                                transition: 'all 0.2s',
                                border: '1px solid #ff4444',
                                boxShadow: '0 1px 3px rgba(0,0,0,0.2)'
                              }}
                              onMouseOver={(e) => {
                                e.target.style.backgroundColor = '#ff4444';
                                e.target.style.transform = 'scale(1.1)';
                              }}
                              onMouseOut={(e) => {
                                e.target.style.backgroundColor = 'rgba(255, 68, 68, 0.7)';
                                e.target.style.transform = 'scale(1)';
                              }}
                            >
                              ×
                            </div>
                          </div>
                        ))
                      ) : (
                        <Typography variant="body2" sx={{ color: '#FFFFFF', opacity: 0.7 }}>
                          No instruments selected yet.
                        </Typography>
                      )}
                    </div>
                  </div>
                  
                </div>
              ) : (
                <Typography variant="subtitle1" sx={{ color: '#FFFFFF' }}>
                  No instruments or dates selected yet.
                </Typography>
              )}
            </Box>
            </>
          
        ) : (
          <Box 
            display="flex" 
            justifyContent="center" 
            alignItems="center" 
            sx={{ 
              height: '200px',
              color: '#FFFFFF',
              fontSize: '16px'
            }}
          >
            Loading instruments...
          </Box>
        )}
    <button
      onClick={() => plotChart(false)}
      style={{
        padding: '12px 32px',
        backgroundColor: '#2f5cdb',
        color: 'white',
        border: 'none',
        borderRadius: '6px',
        fontSize: '14px',
        fontWeight: 500,
        cursor: 'pointer',
        transition: 'background-color 0.3s ease',
        minWidth: '200px',
        height: '48px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
      }}
      onMouseOver={(e) => e.target.style.backgroundColor = '#1e4cb3'}
      onMouseOut={(e) => e.target.style.backgroundColor = '#2f5cdb'}
    >
      Plot Payoff
    </button>
      {(instrumentList?.length > 0 || dateList?.length > 0) && (
        <button
          onClick={() => resetPayoff()}
          style={{
            padding: '12px 32px',
            marginLeft: '20px',
            backgroundColor: 'rgba(255, 68, 68, 0.7)',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            fontSize: '14px',
            fontWeight: 500,
            cursor: 'pointer',
            transition: 'background-color 0.3s ease',
            minWidth: '200px',
            height: '48px',
            boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
          }}
            onMouseOver={(e) => {
              e.target.style.backgroundColor = '#ff4444';
            }}
            onMouseOut={(e) => {
              e.target.style.backgroundColor = 'rgba(255, 68, 68, 0.7)';
            }}
        >
          Clear All Selections
        </button>)}

        
    {isAdmin ? 
    <button
      onClick={() => getBrokerPos()}
      style={{
        padding: '12px 32px',
        backgroundColor: '#2f5cdb',
        color: 'white',
        border: 'none',
        borderRadius: '6px',
        fontSize: '14px',
        fontWeight: 500,
        cursor: 'pointer',
        transition: 'background-color 0.3s ease',
        minWidth: '200px',
        height: '48px',
        marginLeft: '20px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
      }}
      onMouseOver={(e) => e.target.style.backgroundColor = '#1e4cb3'}
      onMouseOut={(e) => e.target.style.backgroundColor = '#2f5cdb'}
    >
      Get Broker Active Positions
    </button>
    : <></>
    }
    <br/>
    <br/>
    <Box
            display="flex"
            justifyContent="left"
            alignItems="left"
            sx={{
              height: '200px',
              color: '#FFFFFF',
              fontSize: '16px'
            }}
          >
              {plotInstrumentList?.length > 0 ? (
                <div>
                  <Typography variant="subtitle1" sx={{ color: '#FFFFFF', marginBottom: '16px' }}>
                    Payoff Plot done for following Instruments (Net Combined Delta of Positions: {posDelta}){/* {isAdmin?" (Combined Delta: "+ posDelta+")":""} */}:
                  </Typography>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    <table border="1" cellpadding="6" cellspacing="0">
                          <thead>
                            <tr>
                              <th>Instrument</th>
                              <th title='Last Traded Price'>&nbsp;LTP&nbsp;</th>
                              <th title='Theta Decay in option price - till selected future date/time - assuming constant underlying'>&nbsp;Decay&nbsp;</th>
                              <th title='Total position size'>&nbsp;Size&nbsp;</th>
                              <th title='Quantity in number of lots'>&nbsp;Qty&nbsp;</th>
                              <th title='Delta of Option as per current LTP'>delta</th>
                              <th title='Gamma of Option as per current LTP'>gamma</th>
                              <th title='Implied Volatility as per current LTP'>&nbsp;IV&nbsp;</th>
                            </tr>
                          </thead>
                          <tbody>
                      {plotInstrumentList.map((item, index) => (
                      
                        // <div key={index} style={{ color: '#FFFFFF', fontSize: '14px' }}>
                        //   <strong>{item.name}</strong>&nbsp;&nbsp;&nbsp;&nbsp;LTP: {item.ltp}&nbsp;&nbsp;Size: {item.lot_size}&nbsp;&nbsp;({item.size} lots)
                        // </div>
                            <tr>
                              <td>&nbsp;&nbsp;{item.name}&nbsp;&nbsp;</td>
                              <td title='Last Traded Price' align='right'>&nbsp;&nbsp;{item.ltp}&nbsp;&nbsp;</td>
                              <td title='Theta Decay in option price - till selected future date/time - assuming constant underlying' align='right'>&nbsp;&nbsp;{item.projected_price? (item.projected_price - item.ltp).toFixed(2) : 0}&nbsp;&nbsp;</td>
                              <td title='Total position size' align='right'>&nbsp;&nbsp;{item.lot_size}&nbsp;&nbsp;</td>
                              <td title='Quantity in number of lots' align='right'>&nbsp;&nbsp;{item.size}&nbsp;&nbsp;</td>
                              <td title='Delta of Option as per current LTP' align='right'>&nbsp;&nbsp;{item.delta}&nbsp;&nbsp;</td>
                              <td title='Gamma of Option as per current LTP' align='right'>&nbsp;&nbsp;{item.gamma}&nbsp;&nbsp;</td>
                              <td title='Implied Volatility as per current LTP' align='right'>&nbsp;&nbsp;{item.iv}&nbsp;&nbsp;</td>
                            </tr>
                      ))}
                          </tbody>
                      </table>
                    {
                    isAdmin && getActiveBrokerPos?
                      <pre>Broker Postion metadata: {JSON.stringify(brokerMdata, null, 2)}</pre>
                    :<></>
                    }
                  </div>
                </div>
              ) : (
                <Typography variant="subtitle1" sx={{ color: '#FFFFFF' }}>
                  No instruments to plot.
                </Typography>
              )}
            </Box>
      </div>
    </ConfigProvider>
  );
};